import { useQuery } from '@tanstack/react-query';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getReturnOrder } from '../../../apis/queries';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import OrderSummary from '../../Orders/OrderDetailPage/OrderSummary';

const ReturnOrderDetails = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <ReturnOrderDetailsContent id={id} />;
};

const ReturnOrderDetailsContent = ({ id }: { id: string }) => {
  const RETURN_ORDER_ID_QUERY_KEY = ['returnOrders', { id }];
  const { data, isLoading } = useQuery({
    queryKey: RETURN_ORDER_ID_QUERY_KEY,
    queryFn: () => getReturnOrder(id)
  });

  const returnOrder = data?.data;

  if (isLoading)
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" />
      </Container>
    );

  if (!returnOrder) {
    return <DetailNotFound />;
  }

  const customer = returnOrder.customer;

  return (
    <div className="main-content">
      <Header title={`${customer?.name} - ${returnOrder.returnOrderNumber}`} isDetailPage />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            {returnOrder && <OrderSummary customer={customer} returnOrder={returnOrder} title="Return Order Details" />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReturnOrderDetails;
